var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgSolutionLine3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 453,
    viewBox: "0 0 2 453",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_518_27892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0V452.006",
    stroke: "#0071B9",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_518_27892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 452.007,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSolutionLine3);
export default __webpack_public_path__ + "static/media/img-solution-line-3.c62ced1d.svg";
export { ForwardRef as ReactComponent };